import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import {
  ImageScaleView,
  ImageSliceView,
  ImageSliceViewOpts,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { GENERIC_AVATAR } from 'src/replicant/profile/assets';

import { AssetGroup } from '@play-co/timestep-core';

type Friend = {
  name: string;
  photo: string;
  accepted: boolean;
};

type CloseHandler = (result: boolean) => void;
const ui = uiConfig.buruburu.invite.confirm;

export default class PopupDuoResponseSuccess extends PopupBasic {
  private close: CloseHandler;
  private name: LangBitmapFontTextView;
  private photo: ImageScaleView;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      ...ui.popup,
      height: 490,
      tracking: {
        feature: Feature.DUO._,
        $subFeature: Feature.DUO.RESPOSE_SUCCESS_POPUP._,
      },
    });

    this.close = opts.close;
    this.buttonClose.removeFromSuperview();

    this.message.updateOpts({
      ...ui.message,
      width: this.box.style.width - 2 * ui.message.x,
    });

    this.box.addSubview(
      new ImageScaleView({
        ...ui.underline,
        width: this.message.style.width,
        y: 145,
      }),
    );

    const friendPanel = this.box.addSubview(
      new ImageSliceView({
        ...(uiConfig.buruburu.invite.confirm.friendPanel as ImageSliceViewOpts),
      }),
    );

    this.photo = friendPanel.addSubview(new ImageScaleView(ui.icon));

    this.name = friendPanel.addSubview(new LangBitmapFontTextView(ui.name));

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...ui.okButton,
        x: 160,
        y: 360,
        localeText: () => i18n('basic.okay'),
        onClick: async () => {
          sounds.sfx.play('ok');
          return opts.close(true);
        },
        tracking: {
          feature: Feature.DUO._,
          $subFeature: Feature.DUO.RESPOSE_SUCCESS_POPUP.CLOSE,
        },
      }),
    );
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init({ name, photo, accepted }: Friend) {
    super.init({
      title: i18n('duo.responseSuccess.title'),
      message: i18n(
        `duo.responseSuccess.message-${accepted ? 'accepted' : 'declined'}`,
      ),
    });

    this.name.localeText = () => name;
    this.photo.setImage(photo ?? GENERIC_AVATAR);
  }
}
